import { Component, ViewChild } from '@angular/core'
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, FeatureType } from '../../shared'
import { SwpppDashboardComponent } from './swppp-dashboard.component'
import { SwpppSitesComponent } from './swppp-sites.component'

@Component({
    selector: 'app-swppp',
    templateUrl: './swppp.component.html',
    standalone: true,
    imports: [NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, SwpppDashboardComponent, SwpppSitesComponent],
})
export class SwpppComponent extends BaseComponent {
    @ViewChild(SwpppDashboardComponent) dashboard?: SwpppDashboardComponent

    activeTab = 0

    constructor() {
        super()
        this.activeTab = this.canViewDashboard ? 0 : 1
        this.initialLoadingComplete()
    }

    tabChanged() {
        if (this.isDashboardTab) this.dashboard?.refresh()
        setTimeout(() => window.dispatchEvent(new Event('resize')), 50)
    }

    get canViewDashboard() {
        return this.services.authentication.hasFeature([FeatureType.FieldToolsSwpppDashboardView])
    }

    get isDashboardTab() {
        return Number(this.activeTab) === 0
    }

    get isRecordsTab() {
        return Number(this.activeTab) === 1
    }
}
